module.exports = __webpack_public_path__ + "static/assets/c9e1f638100c131564e03bb4b18be3e0.svg";